import * as cookies from "@kiwicom/nitro/lib/services/session/cookies"
import { Cookie } from "@kiwicom/cookies"

import { getUser } from "../auth"

/**
 * @deprecated
 * use 'getUser' directly
 */
export const userSelector = getUser
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getUserAffilId: any = () => cookies.load(Cookie.AFFILIATE_ID)
